import Swiper, { Autoplay, Navigation, Pagination, Thumbs } from 'swiper';

/* =======================
//     Critical CSS     //
======================= */

document.querySelectorAll('link[rel="preload"]').forEach(function(styles) {
  var criticalCSS = styles.cloneNode(true);
  criticalCSS.setAttribute('rel', 'stylesheet');
  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(criticalCSS);
  console.log("css success");
});

/* ====================================
//     Lazyload Background Image     //
==================================== */

document.addEventListener("DOMContentLoaded", function() {
  var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function(lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});

const imageSwiper = new Swiper(".image-swiper", {
modules: [Navigation],

// Optional parameters
slidesPerView: 2,
centerInsufficientSlides: true,
spaceBetween: 10,

watchSlidesProgress: true,
freeMode: true,

// Responsive breakpoints
breakpoints: {
  768: {
    slidesPerView: 3,
    spaceBetween: 6,
  }
}, 
  navigation: {
    nextEl: ".image-swiper-next",
    prevEl: ".image-swiper-prev",
},
  
});

const mainImageSwiper = new Swiper(".main-image-swiper", {
  modules: [Navigation, Thumbs],
  spaceBetween: 10,
  thumbs: {
    swiper: imageSwiper,
  },
  navigation: {
    nextEl: ".main-image-button-next",
    prevEl: ".main-image-button-prev",
  }
  
});

const heroSwiper = new Swiper('.hero-swiper', {
  modules: [Autoplay, Navigation],
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const partsAccessoriesLandingSwiper = new Swiper('.parts-accessories-landing-swiper', {
  modules: [Navigation],
  
  // Optional parameters
  slidesPerView: 1,
  centerInsufficientSlides: true,
  // Responsive breakpoints
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 66,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 45,
    }
  },
  
  navigation: {
    nextEl: '.hero-swiper-button-next-custom',
    prevEl: '.hero-swiper-button-prev-custom',
  },
});

const gridCtasSwiper = new Swiper('.grid-ctas-swiper ', {
  modules: [Navigation, Pagination],
  
  // Optional parameters
  slidesPerView: 1,
  centerInsufficientSlides: true,
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 2,
      centerInsufficientSlides: true,
    }
  },
  
  navigation: {
    nextEl: '.grid-cta-swiper-button-next-custom',
    prevEl: '.grid-cta-swiper-button-prev-custom',
  },
  
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});

const relatedBikesSwiper = new Swiper('.related-bikes-swiper-button', {
  modules: [Navigation, Pagination],
  

  // Responsive breakpoints
  grid: {
    rows: 4,
  },
  
  slidesPerView: 2,
  
  
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 4,
      spaceBetween: 66,
      centerInsufficientSlides: true,
      grid: {
        rows: 1,
      },

    },
  },
  
  navigation: {
    nextEl: '.related-bikes-swiper-button-next-custom',
    prevEl: '.related-bikes-swiper-button-prev-custom',
  },
  
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});

const bikesSwiper = new Swiper('.bikes-swiper', {
  modules: [Navigation, Pagination],
  
  // Optional parameters
  slidesPerView: 1,
  centerInsufficientSlides: true,
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 4,
      spaceBetween: 6,
      grid: {
        rows: 1,
      },
    }
  },
  
  navigation: {
    nextEl: '.bikes-swiper-button-next-custom',
    prevEl: '.bikes-swiper-button-prev-custom',
  },
  
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});

const productSwiper = new Swiper('.product-swiper', {
  modules: [Navigation, Pagination],
  
  // Optional parameters
  slidesPerView: 1,
  centerInsufficientSlides: true,
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 4,
      spaceBetween: 6,
      grid: {
        rows: 1,
      },
    }
  },
  
  navigation: {
    nextEl: '.product-swiper-button-next-custom',
    prevEl: '.product-swiper-button-prev-custom',
  },
  
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});


const ctasSwiper = new Swiper('.ctas-swiper', {
  modules: [Navigation, Pagination],
  
  // Optional parameters
  slidesPerView: 1,
  centerInsufficientSlides: true,
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 4,
      spaceBetween: 6,
      grid: {
        rows: 1,
      },
    }
  },
  
  navigation: {
    nextEl: '.ctas-swiper-button-next-custom',
    prevEl: '.ctas-swiper-button-prev-custom',
  },
  
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});

const teamSwiper = new Swiper('.team-swiper ', {
  modules: [Navigation, Pagination],
  
  // Optional parameters
  slidesPerView: 1,
  centerInsufficientSlides: true,
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 3,
      centerInsufficientSlides: true,
      spaceBetween: 66,
    }
  },
  
  navigation: {
    nextEl: '.grid-cta-swiper-button-next-custom',
    prevEl: '.grid-cta-swiper-button-prev-custom',
  },
  
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});

const newsSwiper = new Swiper('.news-swiper', {
  modules: [Navigation, Pagination],
  
  // Optional parameters
  slidesPerView: 1,
  centerInsufficientSlides: true,
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 2,
      grid: {
        rows: 2,
      },
    }
  },
  
  navigation: {
    nextEl: '.news-swiper-button-next-custom',
    prevEl: '.news-swiper-button-prev-custom',
  },
  
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});

const otherBikes = new Swiper('.other-bikes ', {
  modules: [Navigation, Pagination],
  
  // Optional parameters
  slidesPerView: 1,
  centerInsufficientSlides: true,
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 3,
      centerInsufficientSlides: true,
      spaceBetween: 96,
    }
  },
  
  navigation: {
    nextEl: '.grid-cta-swiper-button-next-custom',
    prevEl: '.grid-cta-swiper-button-prev-custom',
  },
  
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});


function toggleMobileMenu() {
  var links = document.querySelector("#main-nav");
  document.querySelector("#menu-toggle .icon-hamburger").classList.toggle("hidden"); 
  document.querySelector("#menu-toggle .icon-close").classList.toggle("hidden"); 
  links.classList.toggle("hidden");
}

if (document.querySelector('#menu-toggle') != null) {
  document.querySelector('#menu-toggle').addEventListener('click', function() {
    toggleMobileMenu(); 
  });
}

function toggleMobileSubmenu(subMenuId, scrollTarget) {
  if (screen.width < 1024) {
    var openSubmenu = document.querySelector(".submenu.max-h-96");
    
    if (openSubmenu && openSubmenu.id != subMenuId) {
      openSubmenu.classList.toggle("max-h-0");
      openSubmenu.classList.toggle("max-h-96");
      openSubmenu.classList.toggle("z-[99]");
      openSubmenu.classList.toggle("z-[100]");
      openSubmenu.previousElementSibling.querySelector(".icon-chevron-down").classList.toggle("rotate-180");
    }
    
    var submenu = document.querySelector("#" + subMenuId);
    submenu.classList.toggle("max-h-0");
    submenu.classList.toggle("max-h-96");
    submenu.classList.toggle("z-[99]");
    submenu.classList.toggle("z-[100]");
    submenu.previousElementSibling.querySelector(".icon-chevron-down").classList.toggle("rotate-180");
    
    if (scrollTarget != "") {
      document.querySelector("#" + scrollTarget).scrollIntoView();
    }
  }
}

let navigatePage = true;
document.querySelectorAll(".submenu-toggle").forEach(function(el) {
  el.addEventListener("pointerdown", function(event) {
    if (event.pointerType === "touch") {
      navigatePage = false;
    } else {
      navigatePage = true;
    }
  }, false);
  
  el.addEventListener("click", function(event) {
    if (!navigatePage) {
      event.preventDefault();
      toggleMobileSubmenu(el.dataset.submenuId, el.dataset.scrollTarget);
    }
  });
});

document.querySelectorAll(".subnavmenu-toggle").forEach(function(el) {
  el.addEventListener("click", function(event) {
    document.querySelectorAll(".subnavmenu-toggle.bg-highlight-grey").forEach(el => {
       el.classList.remove("bg-highlight-grey");
    });
    var subNavMenuTrigger = event.currentTarget; 
    var subNavMenuId = subNavMenuTrigger.dataset.subnavmenuId; 
    var openSubNavMenu = document.querySelector(".subNavMenu.block");
    if(openSubNavMenu && openSubNavMenu.id != subNavMenuId) {
      openSubNavMenu.previousElementSibling.querySelector(".icon-chevron-down").classList.toggle("rotate-180");
      openSubNavMenu.classList.toggle("block");
      openSubNavMenu.classList.toggle("hidden");
    }
    subNavMenuTrigger.classList.toggle("bg-highlight-grey");
    var downArrow = subNavMenuTrigger.querySelector(".icon-chevron-down");
    if(downArrow){
     downArrow.classList.toggle("rotate-180");
    }
    var subNavMenu = document.querySelector("#" + subNavMenuId);
    subNavMenu.classList.toggle("hidden");
    subNavMenu.classList.toggle("block");
    
    event.preventDefault();
  });
});


function toggleAccordion(expandId, expandedHeight) {
 var accordion = document.querySelector("#" + expandId);
 
 accordion.classList.toggle("max-h-0");
 accordion.classList.toggle(expandedHeight);
 accordion.classList.toggle("overflow-hidden");
 accordion.classList.toggle("overflow-auto");

}

if (document.querySelectorAll('.accordion-header') != null) {
  document.querySelectorAll('.accordion-header').forEach(el => el.addEventListener('click', function() {
    toggleAccordion(el.dataset.expand, el.dataset.expandedHeight); 
    el.querySelector(".icon-chevron-down").classList.toggle("rotate-180");
  }));
}

// tabs


function openTabs(ev) {
   var btnTarget = ev.currentTarget;
   var activeLabelClass = btnTarget.dataset.activeLabelClass; 
   var tabset = document.querySelector("#" + btnTarget.dataset.tabset)
   var tab = tabset.querySelector("#" + btnTarget.dataset.tab);
   var currentTabLabel = tabset.querySelector(".tab-label." + activeLabelClass); 
   var currentTab = tabset.querySelector("#" + currentTabLabel.dataset.tab);
   
  if (tab.id != currentTab.id) {
   
    btnTarget.classList.add(activeLabelClass); 
    tab.classList.remove("hidden");
  
    currentTabLabel.classList.remove(activeLabelClass);
    currentTab.classList.add("hidden"); 
  }

}

document.querySelectorAll(".tab-label").forEach(function(el) {
   el.addEventListener("click", openTabs);
});

// modal

function toggleVisibility(ev) {
  event = ev || window.event;
  if (event.target == ev.currentTarget) {
    var btnTarget = ev.currentTarget;
    var modal = document.querySelector("#" + btnTarget.dataset.modalId);
    modal.classList.toggle("opacity-0");
    modal.classList.toggle("invisible");
  }
}

document.querySelectorAll(".modal-toggle").forEach(function(el) {
   el.addEventListener("click", toggleVisibility);
});

//Countdown timer
document.addEventListener("DOMContentLoaded", function() {
  const timerDiv = document.querySelector("#countdown-timer");
  if (timerDiv) {
    let deadline = new Date(timerDiv.dataset.endDate).getTime();

    let x = setInterval(function () {

      let now = new Date().getTime();
      let t = deadline - now;
      let days = Math.floor(t / (1000 * 60 * 60 * 24));
      let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((t % (1000 * 60)) / 1000);

      let daysText, hoursText, minText, secText;

      if (days == 1) {
        daysText = " Day ";
      } else {
        daysText = " Days ";
      }
      if (hours == 1) {
        hoursText = " Hour ";
      } else {
        hoursText = " Hours ";
      }
      if (minutes == 1) {
        minText = " Min ";
      } else {
        minText = " Mins ";
      }
      if (seconds == 1) {
        secText = " Sec";
      } else {
        secText = " Secs";
      }


      if (days > 0) {
        timerDiv.innerHTML = days + daysText + hours + hoursText + minutes + minText + seconds + secText;
      } else if (hours > 0) {
        timerDiv.innerHTML = hours + hoursText + minutes + minText + seconds + secText;
      } else if (minutes > 0) {
        timerDiv.innerHTML = minutes + minText + seconds + secText;
      } else if (seconds > 0) {
        timerDiv.innerHTML = seconds + secText;
      } else {
        timerDiv.innerHTML = "Sale has ended";
      }

    }, 1000);
  }

});

function toggleImageModal(ev) {
  event = ev || window.event;
  if (event.target == ev.currentTarget) {

    var btnParent = ev.currentTarget.parentElement;
    let imageModal = document.querySelector("#image-modal");
    imageModal.classList.toggle("opacity-0");
    imageModal.classList.toggle("invisible");

    if (btnParent.hasAttribute("data-image-url")) {
      imageModal.querySelector("img").src = btnParent.dataset.imageUrl;
    } else {
      imageModal.querySelector("img").src = "";
    }
  }
}

document.querySelectorAll(".image-modal-btn").forEach(function(el) {
  el.addEventListener("click", toggleImageModal);
});

window.onscroll = function() {scrollFunction()}; 

function scrollFunction() {
  if (document.getElementById("edit-filters")) {
    if (document.body.scrollTop > 800 || document.documentElement.scrollTop > 800) {
      document.getElementById("edit-filters").classList.remove("hidden");
    } else {
      document.getElementById("edit-filters").classList.add("hidden");
    }
  }
} 

document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.brand-tab-content');
  const hub = document.getElementById('hub-view');
  const backButtons = document.querySelectorAll('.back-to-hub');

  function showTab(tabName, scroll = true) {
    // Hide hub
    hub.classList.add('hidden');

    // Hide all tab contents
    tabContents.forEach(content => {
      content.classList.add('hidden');
    });

    // Show selected tab content
    const activeTab = document.getElementById(tabName);
    if (activeTab) {
      activeTab.classList.remove('hidden');
      if (scroll) activeTab.scrollIntoView({ behavior: 'smooth' });
    }

    // Highlight the correct tab button
    tabButtons.forEach(button => {
      const isActive = button.dataset.tab === tabName;
      button.classList.toggle('ring-2', isActive);
      button.classList.toggle('ring-black', isActive);
      button.classList.toggle('bg-yellow-100', isActive);
    });
  }

  function showHub() {
    // Show the hub
    hub.classList.remove('hidden');

    // Hide all tab contents
    tabContents.forEach(content => {
      content.classList.add('hidden');
    });

    // Clear active button styles
    tabButtons.forEach(button => {
      button.classList.remove('ring-2', 'ring-black', 'bg-yellow-100');
    });

    hub.scrollIntoView({ behavior: 'smooth' });

    // Remove hash from URL without reloading
    history.pushState("", document.title, window.location.pathname + window.location.search);
  }

  // Handle tab button clicks
  tabButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      const tabName = button.dataset.tab;
      showTab(tabName);
      history.pushState(null, null, `#${tabName}`);
    });
  });

  // Handle back buttons
  backButtons.forEach(back => {
    back.addEventListener('click', e => {
      e.preventDefault();
      showHub();
    });
  });

  // Load tab from hash on page load
  const initialHash = window.location.hash.replace('#', '');
  if (initialHash) {
    showTab(initialHash, false); // Don't scroll if already in view
  }
});
